import { Typography, useTheme, Tab, Tabs, Box, IconButton, Stack } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useEffect, useState } from 'react';
import TimelineRoundedIcon from '@mui/icons-material/TimelineRounded';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import VoyageDetails from './VoyageDetails';
import { CancelToken } from 'apisauce';
import appapi from '../../../../api/apiClient';
import ActivityIndicator from '../../../../components/DataTable/ActivityIndicator';
import TabPanel from './../../../../components/TabPanel';
import Reports from './Reports';
import format from '../../../../assets/images/format.svg';
import formatDisable from '../../../../assets/images/formatDisable.svg';
import InsightsIcon from '@mui/icons-material/Insights';
import GraphDetails from './GraphDetails';
import AddVoyage from '../../FleetManagement/Components/AddVoyage';
import { useTranslation } from 'react-i18next';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function VoyageSplitPanel({ isDrawerOpen, toggleDrawer, data, init }) {
  const theme = useTheme();
  let source = CancelToken.source();

  const [tabIndexValue, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [voyageDetails, setVoyageDetails] = useState([]);
  const [openEditVoyage, setOpenEditVoyage] = useState(false);

  const {t} = useTranslation()

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const initApi = async () => {
    await getVoyageDetails();
  };

  useEffect(() => {
    if (data) {
      initApi();
    }
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, [data]);

  const getVoyageDetails = async () => {
    setLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `fleet/voyage/${data?._id}`,
      {},
      {
        cancelToken: source.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setVoyageDetails(data.response);
      }
      setLoading(false);
    }
  };

  return (
    <Stack
      flex={1}
      className={!isDrawerOpen ? 'shrinkside flex' : 'expandside flex'}
    >
      <div className="absolute ml-[-18px]">
        <IconButton
          className="!shadow-2xl"
          sx={{ boxShadow: 'rgba(0, 0, 0, 0.5) 1px 5px 10px !important', '&:hover': { width: '40px !important', marginLeft: '-20px' } }}
          style={{
            color: '#00000',
            width: '20px',
            paddingTop: '10px',
            height: '40px',
            zIndex: 999,
            backgroundColor: '#FFFF',
            borderRadius: '10px 0px 0px 10px',
          }}
          onClick={() => {
            toggleDrawer();
          }}
        >
          <ChevronRightIcon />
        </IconButton>
      </div>
      <Stack
        flex={1}
        style={{ background: '#FFFF', border: !isDrawerOpen ? 'none' : '1px solid #14285A1A', width: !isDrawerOpen ? '0px' : '500px', borderRadius: 1 }}
        onClose={() => {
          toggleDrawer();
        }}
      >
        {isDrawerOpen ? (
          <>
            {loading && (
              <Stack
                flex={1}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <ActivityIndicator />
              </Stack>
            )}
            {!loading && (
              <Stack flex={1}>
                <Box
                  sx={{
                    display: 'flex',
                    borderBottom: 1,
                    border: 'none',
                    color: 'rgba(255, 255, 255, 1)',
                    borderRadius: '5px 5px 0px 0px',
                    justifyContent: 'space-between',
                  }}
                >
                  <Stack style={{ color: theme.palette.primary.text, alignItems: 'center', justifyContent: 'center' }}>
                    <Typography className="!font-medium !ml-[15px] !uppercase"> {t('Details')}</Typography>
                  </Stack>

                  <Tabs
                    sx={{
                      '& .MuiTabs-indicator': {
                        backgroundColor: '#FFCC00 !important',
                      },
                    }}
                    indicatorColor="secondary"
                    value={tabIndexValue}
                    onChange={handleChange}
                  >
                    <Tab
                      sx={{ minHeight: '56px' }}
                      label={
                        <span className={`${tabIndexValue === 0 ? '!text-[#14285A]' : '!text-[#64717C40]'} !uppercase `}>
                          <ListAltRoundedIcon className="mr-[10px]" />
                          {t('Details')}
                        </span>
                      }
                      {...a11yProps(0)}
                    />
                    <Tab
                      sx={{ minHeight: '56px' }}
                      label={
                        <span className={`${tabIndexValue === 1 ? '!text-[#14285A]' : '!text-[#64717C40]'} `}>
                          <InsightsIcon className="mr-[10px]" />
                          {t('Graphs')}
                        </span>
                      }
                      {...a11yProps(1)}
                    />
                    <Tab
                      sx={{ minHeight: '56px' }}
                      label={<span className={`${tabIndexValue === 2 ? '!text-[#14285A]' : '!text-[#64717C40]'} `}>{t('Reports')}</span>}
                      icon={
                        tabIndexValue === 2 ? (
                          <img
                            src={format}
                            style={{ width: '16px', height: '12px' }}
                          />
                        ) : (
                          <img
                            src={formatDisable}
                            style={{ width: '16px', height: '12px' }}
                          />
                        )
                      }
                      iconPosition="start"
                      {...a11yProps(2)}
                    />
                  </Tabs>
                </Box>
                <Stack style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }} />
                {tabIndexValue === 0 && (
                  <TabPanel
                    className="flex flex-col flex-1 min-h-0"
                    value={tabIndexValue}
                    index={0}
                  >
                    <VoyageDetails data={voyageDetails}  openEditVoyage={() => setOpenEditVoyage(true)} details={data}/>
                  </TabPanel>
                )}
                {tabIndexValue === 1 && (
                  <TabPanel
                    className="flex flex-col flex-1 min-h-0"
                    value={tabIndexValue}
                    index={1}
                  >
                    <GraphDetails
                      data={data}
                      voyageDetails={voyageDetails}
                     
                    />
                  </TabPanel>
                )}
                {tabIndexValue === 2 && (
                  <TabPanel
                    className="flex flex-col flex-1 min-h-0"
                    value={tabIndexValue}
                    index={2}
                  >
                    <Reports
                      voyageDetails={voyageDetails}
                      data={data}
                    />
                  </TabPanel>
                )}
              </Stack>
            )}
          </>
        ) : null}
      </Stack>
      {openEditVoyage && (
        <AddVoyage
          modelOpen={openEditVoyage}
          onModelHandleClose={(event) => {
            if (event) {
              getVoyageDetails();
              init();
            }
            setOpenEditVoyage(false);
          }}
          // partyInfo={companyDetails}
          // ship={shipDetails}
          type={'edit'}
          details={voyageDetails}
        />
      )}
    </Stack>
  );
}
